initAction(initFilterInputs);
initFiltersOptions(parseBranches());
function parseBranches() {
    const branchesDataRaw = document.getElementById("branches-data")?.textContent;
    const branchesDataParsed = JSON.parse(branchesDataRaw || "{}");
    const cityAndAreaList = branchesDataParsed.flatMap((branch) => {
      const { area, city } = branch;
      if (!city && !area) {
        return [];
      }
      return { city, area };
    });
    return cityAndAreaList;
}

function initFiltersOptions(cityAndAreaList) {
    const formElement = document.querySelector('form.filters');
    formElement.querySelectorAll('.branches-filter').forEach((filterWrapper) => {
        const target = filterWrapper.dataset.target;
        const optionsList = filterWrapper.querySelector('.boa-autocomplete-list');
        optionsList.innerHTML = '';
        const uniqueOptions = cityAndAreaList.reduce((acc, cityAndArea) => {
            if (acc.includes(cityAndArea[target])) {
                return acc;
            }
            acc.push(cityAndArea[target]);
            return acc;
        }, []);
        uniqueOptions.forEach((optionValue) => {
            const option = document.createElement('li');
            if (target === 'city') {
                option.dataset.area = cityAndAreaList.find(({ city }) => city === optionValue)?.area;
            }
            option.textContent = optionValue;
            option.addEventListener('click', () => {
                option.closest('.branches-filter').querySelector('input').value = optionValue;
                filterBranches(optionValue, target)
                if (target === 'area') {
                    document.querySelector('.branches-filter[data-target="city"]').querySelector('input').value = '';
                    document.querySelectorAll('.branches-filter[data-target="city"] .boa-autocomplete-list li').forEach((option) => {
                        if (option.dataset.area === optionValue) {
                            option.classList.remove('hidden');
                        } else {
                            option.classList.add('hidden');
                        }
                    });
                }
            })
            optionsList.append(option);
        })
    });
}


function filterBranches(term, field, addFilter=true) {
    const branchItemCollection = document.querySelectorAll('div.boa-branch-item');
    branchItemCollection.forEach((branchItem) => {
        // Show all
        if (!term && !field) {
            branchItem.dataset.selectedFilters = "";
            return branchItem.classList.remove('hidden');
        }
        const regex = new RegExp(`\\+${field}:[^+]*`);
        branchItem.dataset.selectedFilters = branchItem.dataset.selectedFilters.replace(regex,'');
        if(addFilter){
            branchItem.dataset.selectedFilters = `${branchItem.dataset.selectedFilters}+${field}:${term}`;
        }
        const branchData = JSON.parse(branchItem.dataset.filters.trim());
        const currentFilters = branchItem.dataset.selectedFilters.split('+');
        const hideBranch = currentFilters.some(filter=>{
            if(filter.length === 0){
                return false;
            }
            const [curField, curTerm] = filter.split(':');
            if(curField === 'filters'){
                return !branchData[curTerm];
            }else if(!curTerm || curTerm.length < 1){
                resetAutocompleteFilter();
                return false;
            }else{
                return branchItem.dataset[curField].trim().toUpperCase() !== curTerm.trim().toUpperCase();
            }
        })
       
        branchItem.classList.toggle('hidden', hideBranch);
    });
    document.querySelectorAll('.boa-autocomplete-list').forEach(optionsList => optionsList.classList.add('hidden'));
}

function initFilterInputs() {
    const formElement = document.querySelector('form.filters');
    formElement.querySelectorAll('.branches-filter').forEach((filterWrapper) => {
        const optionsList = filterWrapper.querySelector('.boa-autocomplete-list');

        const input = filterWrapper.querySelector('input');
        input.addEventListener('input', (e) => {
            const optionElements = optionsList.querySelectorAll('li');
            const term = e.target.value.trim().toUpperCase();
            if(term === ''){
                const target = filterWrapper.dataset.target;
                filterBranches(term, target, false)
                if(target === 'area'){
                    filterBranches(term, 'city', false);
                    resetFilters(false);
                }
                return;
            }
            let hasAtLeastOneOptionVisible = false;
            optionElements.forEach((option) => {
                const isMatch = option.textContent.trim().toUpperCase().includes(term);
                option.classList.toggle('hidden', !isMatch);
                hasAtLeastOneOptionVisible ||= isMatch;
            });
            if (hasAtLeastOneOptionVisible) {
                optionsList.classList.remove('hidden');
            } else {
                optionsList.classList.add('hidden');
            }
        });
        input.addEventListener('focus', () => {
            optionsList.classList.remove('hidden');
        });
        let mouseOverOptions = false;
        input.addEventListener('blur', () => {
            if (!mouseOverOptions) {
                optionsList.classList.add('hidden');
            }
        });
        optionsList.addEventListener('mousedown', () => {
            mouseOverOptions = true;
            setTimeout(() => {
                mouseOverOptions = false;
            });
        })
    });
    formElement.querySelector('#reset-filters-button').addEventListener('click', resetFilters);
    formElement.querySelectorAll('.branches-filter-check input').forEach(checkbox=> checkbox.addEventListener('change', (checkbox) => filterBranches(checkbox.target.name, 'filters', checkbox.target.checked)));
}

function resetFilters(removeCheckboxes=true) {
    document.querySelectorAll('.branches-filter input').forEach((input) => {
        input.value = '';
    });
    resetAutocompleteFilter();
    if(removeCheckboxes){
        filterBranches();
        document.querySelectorAll('.branches-filter-check input').forEach(checkbox=> checkbox.checked = false);
    }
}

function resetAutocompleteFilter(){
    document.querySelectorAll('.boa-autocomplete-list').forEach((optionsList) => {
        optionsList.querySelectorAll('li').forEach((optionItem) => {
            optionItem.classList.remove('hidden');
        })
    });
}

function initAction(cb) {
    if (document.readyState !== 'loading') {
        cb();
    } else {
        document.addEventListener('DOMContentLoaded', cb);
    }
};